/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangePatientConfirmationAliases {
  BUTTON_CANCELAR = 'button-cancelar',
  BUTTON_CONFIRMAR = 'button-confirmar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FIELD_ATENDIMENTO = 'field-atendimento',
  FIELD_DESTINO = 'field-destino',
  FIELD_PERMANENCIA = 'field-permanencia',
  FORM_CONFIRMATION = 'form-confirmation',
  FRAGMENT_REFERENCE_0 = 'fragment-reference-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_MAIN = 'layout-main',
  PANEL_LOADER = 'panel-loader',
  TEXT_ATENDIMENTO = 'text-atendimento',
  TEXT_DESTINO = 'text-destino',
  TIME_FIELD_0 = 'time-field-0',
}
export { ChangePatientConfirmationAliases };
